<template>
  <div v-if="numberOfPages > 1">
    <ul class="list-reset flex items-center">
      <li v-for="p in numberOfPages" :key="p">
        <span class="btn pagination-item mr-4 ellipsis"
          v-if="p === numberOfPages && paginationInfo.page + armWidth < numberOfPages">
          ...
        </span>

        <button type="button" class="btn pagination-item mr-4"
          :class="{ 'is-active': p === paginationInfo.page }"
          v-if="isShowing(p)"
          @click="handlePageClick(p)">
          {{ p }}
        </button>

        <span class="pagination-item mr-4 ellipsis"
          v-if="p === 1 && paginationInfo.page - armWidth > 1">
          ...
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['paginationInfo'],
  computed: {
    armWidth () {
      return 2
    },
    numberOfPages () {
      return Math.ceil(this.paginationInfo.total / this.paginationInfo.per_page)
    }
  },
  methods: {
    isShowing (p) {
      if (p === 1 || p === this.numberOfPages) {
        return true
      }

      return (this.paginationInfo.page + this.armWidth) > p
        && (this.paginationInfo.page - this.armWidth) < p
    },
    handlePageClick (page) {
      this.$emit('click', page)
    }
  }
}
</script>

<style scoped>
.pagination-item {
  width: 36px;
  height: 36px;
  padding: 0;
}

.pagination-item.is-active {
  background-color: var(--secondary);
  color: white;
}
</style>